import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import type { GTM } from "../GTMInterfaces";
import type { ServiceWithCashbackFromPartnerCollection } from "./interfaces/ServiceWithCashbackFromPartnerCollection.interface";

export class ServiceWithCashbackAdapter {
  /**
   * @param {Object} ServiceWithCashbackFromPartnerCollection - Services with cashback from partner
   */
  constructor(private servicesWithCashbackFromPartner: ServiceWithCashbackFromPartnerCollection) {}
  /**
   * @param {Object} GTM.ServiceExtended - GTM Service
   * @desc Apply the value of matching (by unique identifier) Service with cashback from partner to "gtm service", and return it
   */
  fromGTMExtendedService(service: GTM.ServiceExtended): GTM.ServiceExtended {
    if (isEmpty(service.unique_identifier)) {
      throw new Error("Not convertible Service, dont have unique identifier");
    }

    if (!isString(service.unique_identifier)) {
      throw new Error("Not found Unique identifier");
    }

    const serviceWithCashbackFromPartner = this.servicesWithCashbackFromPartner.get(service.unique_identifier);

    if (!serviceWithCashbackFromPartner) {
      console.error("Not found Service with cashback from partner", service.unique_identifier);
      throw new Error("Not found Service with cashback from partner");
    }

    return {
      ...service,
      price: serviceWithCashbackFromPartner.valueWithTax,
      tax: serviceWithCashbackFromPartner.taxAmount,
    };
  }
}
